import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import * as actions from '../actions'
import axios from 'axios'
import './main.css'
import { Container, Image, FormField, Button, Form, MessageHeader, Message } from 'semantic-ui-react'

const Login = ({ userType }) => {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [formSubmitting, setFormSubmitting] = useState(false)
    const [formIncompleteError, setFormIncompleteError] = useState(false)
    const [invalidLogin, setInvalidLogin] = useState(false)

    const dispatch = useDispatch()
    const history = useHistory()
    
    const handleChangeField = (e) => {
        const { name, value } = e.target
        if (name === 'email') setEmail(value)
        if (name === 'password') setPassword(value)
        if (email !== '' && password !== '' && formIncompleteError) setFormIncompleteError(false)
    }

    const handleSubmitClicked = async () => {
        if (email === '' || password === '') {
            setFormIncompleteError(true)
            return
        }
        setFormSubmitting(true)
        await axios.post('/api/logout')
        try {
            if (userType === 'admin') {
                dispatch(actions.loginAdmin(email.toLowerCase(), password, '', (invalidLogin) => {
                    setFormSubmitting(false)
                    if (invalidLogin) {
                        setInvalidLogin(true)
                        return
                    } else {
                        setInvalidLogin(false)
                        history.replace('/admin/home')
                    }
                }))
            } else if (userType === 'reseller') {
                dispatch(actions.loginReseller(email.toLowerCase(), password, '', (invalidLogin) => {
                    setFormSubmitting(false)
                    if (invalidLogin) {
                        setInvalidLogin(true)
                        return
                    } else {
                        setInvalidLogin(false)
                        history.replace('/resellers/home')
                    }
                }))
            } else {
                console.log('invalid userType')
                setFormSubmitting(false)
                return
            }
        } catch (error) {
            setInvalidLogin(true)
            console.error('Login error:', error)
        } finally {
            setFormSubmitting(false)
        }
    }

    const renderLoginFailedMessage = () => {
        if (invalidLogin) {
            return (
                <Message negative>
                    <MessageHeader>Login failed</MessageHeader>
                    <p>Please check your email or password</p>
                </Message>
            )
        }
        return null
    }

    const renderFormIncompleteMessage = () => {
        if (formIncompleteError) return <Message negative><MessageHeader>Please fill in email and password</MessageHeader></Message>
        return null
    }

    return (
        <div className="bodyScoped">
            <Image style={{ marginTop: 60, marginBottom: 30, borderRadius: 22, backgroundColor: 'black' }} size="medium" centered src="/egc-logo.png"/>
            <Container text>
                <Form inverted loading={formSubmitting}>
                    <FormField>
                        <label>Email</label>
                        <input name="email" value={email} onChange={handleChangeField} placeholder="Email"/>
                    </FormField>
                    <FormField>
                        <label>Password</label>
                        <input name="password" value={password} type="password" onChange={handleChangeField} placeholder="Password"/>
                    </FormField>
                    {renderLoginFailedMessage()}
                    {renderFormIncompleteMessage()}
                    <Button style={{ marginTop: 30, backgroundColor: '#007BFF' }} fluid color="black" type="submit" onClick={handleSubmitClicked}>Login</Button>
                </Form>
            </Container>
        </div>
    )
}

export default Login